// extracted by mini-css-extract-plugin
export var columnList = "_dz-0";